import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { EditComponent }                from '../table/cell-components/actions/edit.component';
import { MessagesService }              from '../messages/messages.service';
import { Table }                        from '../table/types/table';
import { TableQueryParameters }         from '../table/types/table-query-parameters';
import { VehicleModel }                 from './models/vehicle';
import { VehiclesService }              from './vehicles.service';
import { VehiclesTransactionLinkModel } from './typings/vehicles.transaction-link';
import { VehiclesTransactionModel }     from './typings/vehicles.transaction';

@Component({
  selector   : 'wor-vehicle-transactions',
  template: require('./vehicle.transactions.component.html')
})
export class VehicleTransactionsComponent implements OnInit {
  @Input() transactions: Array<VehiclesTransactionModel> = [];
  @Input() vehicle     : VehicleModel                    = {} as VehicleModel;

  collapsed = false;

  tableSettings : Table = {
    columns: [
      {
        field : 'transaction_time',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.TIME')
        },
        pipe    : 'date',
        pipeArgs: 'hh:mm a'
      },
      {
        field : 'transaction_note',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.NOTE')
        }
      },
      {
        field : 'transaction_amount',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( transaction : VehiclesTransactionModel ) => this.view(transaction)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TRANSACTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => this.vehiclesService.getTransactionsCount(this.vehicle)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: {
      enabled: false
    },
  };

  constructor (
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService,
    private vehiclesService : VehiclesService
  ) {}

  ngOnInit () : void {
    this.collapsed = !this.transactions.length;
  }

  get ( params : TableQueryParameters ) : Promise<Array<VehiclesTransactionModel>> {
    return this.vehiclesService.getTransactions(this.vehicle, params)
      .then(( transactions : Array<VehiclesTransactionModel> ) => {
        this.transactions = transactions;

        return transactions;
      })
      .catch(error => {
        this.messagesService.error(error);

        return this.transactions;
      });
  }

  view ( transaction : VehiclesTransactionModel ) : void {
    this.vehiclesService.getTransactionLink(transaction)
      .then(( link : VehiclesTransactionLinkModel ) => {
        // The back end names the source document: a sale invoice, a supplier invoice or, on newer back ends, a stock order.
        if ( link.object === 'invoice' ) {
          this.router.stateService.go('app.dealership.sale', {
            customer_id: link.parent_id,
            id         : link.id,
            vehicle_id : link.vehicle_id
          });
        }
        else if ( link.object === 'purchase_order' ) {
          this.router.stateService.go('app.purchase-order', {
            id       : link.id,
            vendor_id: link.parent_id
          });
        }
        else {
          this.router.stateService.go('app.vendor-invoice', {
            id        : link.id,
            vehicle_id: link.vehicle_id,
            vendor_id : link.parent_id
          });
        }
      })
      .catch(error => this.messagesService.error(error));
  }
}
